// extracted by mini-css-extract-plugin
export var assignmentAttempted = "AssignmentAttempted-module--assignmentAttempted--2bmC7";